import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function Layout() {
  return <div className="flex min-h-screen w-full flex-col bg-ivory font-sans text-graphite" data-id="element-58" data-mp="uz2u0bep2x1o">
      <ScrollToTop data-id="element-59" data-mp="798hxw279cih" />
      <Navbar data-id="element-60" data-mp="76mf29q97l6l" />
      <main className="flex-1 pt-20" data-id="element-61" data-mp="29nlbsai5g8x">
        <Outlet data-id="element-62" data-mp="2aox5yzce6rp" />
      </main>
      <Footer data-id="element-63" data-mp="2bgr75dajwfv" />
    </div>;
}